/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import ICONS from "../../../../../assets/Icons";
import LargePopupRedirect from "../../../../../components/_utils/CommonPopups/CommonLargePopupRedirect";
import SmallPopup from "../../../../../components/_utils/CommonSmallPopup";
import SmallPopupWithBulletPoints from "../../../../../components/_utils/CommonSmallPopupWithBulletPoint";
import SmallPopupWithInput from "../../../../../components/_utils/CommonSmallPopupWithInput";
import PrimaryStepper from "../../../../../components/_utils/CommonSteppers/PrimaryStepper";
import CommonToast from "../../../../../components/_utils/CommonToast";
import TopNavComponent from "../../../../../components/_utils/CommonTopNav/TopNavComponent";
import UniversalRefreshToast from "../../../../../components/_utils/UniversalRefreshToast";
import BeneficiaryAccountEditStepBank from "../../../../../components/Accounts/BeneficiaryAccount/BeneficiaryAccountEdit/BeneficiaryAccountEditStepBank/index.jsx";
import BeneficiaryAccountEditStepBankConfirm from "../../../../../components/Accounts/BeneficiaryAccount/BeneficiaryAccountEdit/BeneficiaryAccountEditStepBankConfirm/index.jsx";
import {
  beneficiaryAccountDetailsById,
  resetUpdateBeneficiaryAccount,
  updateBeneficiaryBankDetails,
} from "../../../../../redux/features/accounts/beneficiaryAccount/index.js";
import {
  bankLookUp,
  getIFSCDetails,
  resetBankLookupData,
  resetBankVerification,
  resetBankVerificationError,
  verifyBankAccount,
} from "../../../../../redux/features/sharedResources/sharedResources";
import { beneficiaryTransactionsReject } from "../../../../../redux/features/transactions/beneficiaryTransactions/index.js";
import { scheduledBeneficiaryReject } from "../../../../../redux/features/transactions/scheduleBeneficiaryTransactions/index.js";
import {
  GlobalConfiguration,
  IntervalConfiguration,
  RejectReasonLength,
} from "../../../../../utils/configurationProvider";
import globalText from "../../../../../utils/globalText";
import BeneficiaryTransactionsViewAll from "../../../../Transactions/BeneficiaryTransactions/BeneficiaryTransactionViewall";
import ScheduleBeneficiaryTransactionViewSchedules from "../../../../Transactions/ScheduleBeneficiaryTransactions/ScheduleBeneficiaryTransactionViewSchedules";
import "./index.css";

const BeneficiaryAccountEditBank = () => {
  const { id } = useParams();
  const scrollIt = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const lastVerifyRequestRef = useRef("");
  const lastLookupAccountsRef = useRef([]);
  const lastBankLookupRequestRef = useRef("");

  const [, setBankUserInfo] = useState([]);
  const [, setShowAccInfo] = useState(false);
  const [deniedId, setDeniedId] = useState(null);
  const [activeStep, setActiveStep] = useState(0);
  const [isFocused, setIsFocused] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [showDetails, setShowDetails] = useState(null);
  const [declineReason, setDeclineReason] = useState("");
  const [updateActive, setUpdateActive] = useState(false);
  const [confirmEnable, setConfirmEnable] = useState(false);
  const [createNewedit, setCreateNewEdit] = useState(false);
  const [virtualAccount, setVirtualAccount] = useState(false);
  const [bankLookupNext, setBankLookupNext] = useState(false);
  const [isLeavePopupOpen, setIsLeavePopupOpen] = useState(false);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [isArchivePopupOpen, setIsArchivePopupOpen] = useState(false);
  const [openAssociatePopup, setOpenAssociatePopup] = useState(false);
  const [isNextButtonEnabled, setIsNextButtonEnabled] = useState(false);
  const [isBankLinkedAccount, setIsBankLinkedAccount] = useState(false);
  const [isPendingTxnPopupOpen, setIsPendingTxnPopupOpen] = useState(false);
  const [bankVerificationStatus, setBankVerificationStatus] = useState(false);
  const [isRejectReasonPopupOpen, setIsRejectReasonPopupOpen] = useState(false);
  const [manualVirtualAccount, setManualVirtualAccount] = useState(false);
  const [isOriginalManualVirtual, setIsOriginalManualVirtual] = useState(false);
  const [virtualType, setVirtualType] = useState("");
  const [isPendingSchedulePopupOpen, setIsPendingSchedulePopupOpen] =
    useState(false);
  const [currentAssociate, setCurrentAssociate] = useState(
    "Beneficiary account",
  );
  const [accountActiveInactiveState, setAccountActiveInactiveState] =
    useState("active");

  const [payload, setPayload] = useState({
    bank_account: "",
    ifsc_code: "",
    email_id: "",
    pan_no: "",
    bank_name: "",
    contact_no: "",
    legal_name: "",
    old_bank_account: "",
    old_ifsc_code: "",
    name: "",
    gstin_detail: "",
    virtual_account: "",
    virtual_account_type: "",
    old_virtual_account_type: "",
  });
  const {
    bankLookupLoading,
    bankLookupData,
    verifyBankAccountLoading,
    verifyBankAccountError,
    verifyBankAccountData,
    bankLookupError,
    ifscDetailsData,
    ifscDetailsError,
    ifscDetailsLoading,
    verifiyBankAccountMessage,
  } = useSelector((state) => state.sharedResources);

  const ifscData = ifscDetailsData?.ifsc_details?.[0];

  const dropDownOptions = ["Beneficiary account"];

  const isResolving = verifyBankAccountLoading || bankLookupLoading;

  const ifscRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/;
  const isIFSCValid =
    payload?.ifsc_code?.length === GlobalConfiguration.ifscLength &&
    ifscRegex.test(payload?.ifsc_code);

  const isBankInputValid =
    payload?.bank_account?.length >= GlobalConfiguration.accountnormalLength &&
    payload?.ifsc_code?.length === GlobalConfiguration.ifscLength &&
    ifscRegex.test(payload.ifsc_code);

  const { services } = useSelector((state) => state.refreshToken);

  const { beneficiaryAccountDetailsData, beneficiaryAccountDetailsLoading } =
    useSelector((state) => state.beneficiaryAccount);

  const {
    beneficiaryTransactionsViewAllLoading,
    beneficiaryTransactionsViewAllData,
  } = useSelector((state) => state.beneficiaryTransactions);

  const { scheduledBeneficiaryViewData, scheduledBeneficiaryViewLoading } =
    useSelector((state) => state.scheduleBeneficiaryTransactions);

  const beneficiaryAccount =
    beneficiaryAccountDetailsData?.beneficiary_accounts?.[0];

  const resetVerificationState = () => {
    setVirtualAccount(false);
    setBankVerificationStatus(false);
  };

  const isVirtualDetected =
    virtualAccount ||
    verifyBankAccountData?.verification_details?.[0]?.is_virtual === "Y" ||
    verifyBankAccountData?.verification_details?.[0]?.is_virtual === "y";

  const hasUpdatePermission =
    services?.includes("BUAccount") || services?.includes("Admin");

  const accounts = bankLookupData?.beneficiary_accounts || [];
  const currentPan = payload?.pan_no;
  const currentBank = payload?.bank_account;
  const isNewBank = currentBank !== payload?.old_bank_account;

  const showAlreadyLinkedAlert =
    isNewBank &&
    accounts.some(
      (item) =>
        item?.pan_no === currentPan && item?.bank_acc_no === currentBank,
    );

  const showJointAccountAlert =
    isNewBank &&
    !showAlreadyLinkedAlert &&
    accounts.some(
      (item) =>
        item?.pan_no !== currentPan && item?.bank_acc_no === currentBank,
    );

  const viretualIndicator =
    !isResolving && bankVerificationStatus && bankLookupData !== null;

  const dataArray = [
    {
      previousText: "Cancel",
      nextText: "Next",
      previousEnableBgColor: "var(--primary-nav-act)",
      nextEnableBgColor: "var(--text-primary)",
      previousHoverOption: "white",
      nextHoverOption: "black",
      previousEnableTextColor: "var(--text-primary)",
      previousDisableBgColor: "var(--text-primary)",
      nextEnableTextColor: "var(--primary-bg)",
      nextDisableBgColor: "var(--text-disabled)",
      nextDisableTextColor: "var(--text-primary)",
      nextIsLoading: false,
      nextIsEnabled:
        (isNextButtonEnabled && !isBankLinkedAccount && !isResolving) ||
        isOriginalManualVirtual,
      stepperText: "Bank details",
    },
    {
      previousText: "Previous",
      nextText: "Create",
      previousEnableBgColor: "var(--primary-nav-act)",
      nextEnableBgColor: "var(--text-primary)",
      previousHoverOption: "white",
      nextHoverOption: "black",
      previousEnableTextColor: "var(--text-primary)",
      previousDisableBgColor: "var(--text-disabled)",
      nextEnableTextColor: "var(--primary-bg)",
      nextLoaderNeeded: true,
      nextDisableBgColor: updateActive
        ? "var(--positive-act)"
        : "var(--text-disabled)",
      nextDisableTextColor: "var(--text-primary)",
      nextIsLoading: updateActive,
      nextIsEnabled:
        (isNextButtonEnabled &&
          !isBankLinkedAccount &&
          !updateActive &&
          !isResolving) ||
        isOriginalManualVirtual,
      stepperText: "Confirm and create",
    },
  ];

  const handleBack = () => {
    if (activeStep === GlobalConfiguration.lengthCheckZero) {
      if (hasUnsavedChanges) {
        setIsLeavePopupOpen(true);
        return;
      }

      navigate(-1);
      return;
    }

    setActiveStep((prev) => prev - 1);
  };

  const handleLeavePage = () => {
    navigate(-1);
  };

  const handleNextBank = () => {
    if (isBankLinkedAccount) return;
    if (activeStep !== GlobalConfiguration.lengthCheckOne) {
      setActiveStep((prev) => prev + 1);
      scrollIt.current?.scrollTo({
        left: scrollIt.current.scrollLeft + 1024,
        behavior: "smooth",
      });
    }
  };

  const handleProceedToUpdate = () => {
    if (!hasUpdatePermission) {
      navigate("/feature_not_assigned", {
        state: { unavailableService: "BUAccount" },
      });
      return;
    }

    if (updateActive || isBankLinkedAccount) return;
    if (activeStep === GlobalConfiguration.lengthCheckZero) {
      handleNextBank();
      return;
    }
    setIsArchivePopupOpen(true);
  };

  const submitBankUpdate = async () => {
    try {
      setUpdateActive(true);
      const response = await dispatch(
        updateBeneficiaryBankDetails({
          id,
          bank_account: payload.bank_account,
          ifsc_code: payload.ifsc_code,
          name: payload?.name || payload?.legal_name,
          virtual: manualVirtualAccount || isOriginalManualVirtual,
        }),
      ).unwrap();

      const newBeneId = response?.beneficiary_accounts?.[0]?.id || id;

      dispatch(resetUpdateBeneficiaryAccount());

      navigate(
        `/beneficiary_account_dashboard/beneficiary_account_view_all/beneficiary_account_detail_page/bank_edit_success/${newBeneId}`,
        {
          state: {
            updatedFields: [
              "bank_acc_no",
              "ifsc_code",
              "bank_account_holder_name",
            ],
            updatedPreview: {
              bank_acc_no: payload.bank_account,
              ifsc_code: payload.ifsc_code,
              bank_account_holder_name: payload?.name || payload?.legal_name,
            },
          },
          replace: true,
        },
      );
    } catch (error) {
      CommonToast({
        text:
          error ||
          Object.values(error?.errors || {})?.[0]?.[0] ||
          error?.message ||
          error?.errors?.beneficiary_account ||
          error?.errors?.beneficiary_account?.base?.[0] ||
          error?.errors?.[0]?.bank_account_number?.base?.[0] ||
          "Something went wrong",
        icon: ICONS.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
    } finally {
      setUpdateActive(false);
    }
  };
  const validateAndUpdateBank = async () => {
    setIsArchivePopupOpen(false);
    if (updateActive) return;

    if (beneficiaryAccount?.pending_beneficiary_transactions === "Y") {
      setDeniedId(beneficiaryAccount?.id);
      setIsPendingTxnPopupOpen(true);
      return;
    }

    if (
      beneficiaryAccount?.pending_scheduled_beneficiary_transactions === "Y"
    ) {
      setDeniedId(beneficiaryAccount?.id);
      setIsPendingSchedulePopupOpen(true);
      return;
    }

    await submitBankUpdate();
  };

  const handleInputChange = (event) => {
    const value = event.target.value;
    const sanitizedValue = value.replace(/[^a-zA-Z0-9\s]/g, "");
    const limitedValue = sanitizedValue.slice(
      GlobalConfiguration.lengthCheckZero,
      RejectReasonLength.lengthOfDecline,
    );
    setDeclineReason(limitedValue);
  };

  const computeVariant = (value, focused) => {
    const length = (value ?? "").trim().length;
    if (length === 0) return "default";
    if (length >= GlobalConfiguration.rejectReasonMinLength) return "verified";
    return focused ? "typing" : "error";
  };

  const handleRejectBeneficiaryTxn = async () => {
    if (showLoader) return;
    setShowLoader(true);
    setIsRejectReasonPopupOpen(false);
    let txnIds = [];

    txnIds =
      !beneficiaryTransactionsViewAllLoading &&
      beneficiaryTransactionsViewAllData?.transactions?.length >
        GlobalConfiguration.lengthCheckZero
        ? beneficiaryTransactionsViewAllData?.transactions.map(
            (data) => data?.txn_id,
          )
        : [];

    UniversalRefreshToast("Rejecting transactions.");

    let data = null;

    if (txnIds.length > GlobalConfiguration.lengthCheckZero) {
      data = await dispatch(
        beneficiaryTransactionsReject({
          id: txnIds,
          reason: declineReason,
        }),
      );
    }

    if (
      data?.payload?.errors?.user_unauthorized?.length >
      GlobalConfiguration.lengthCheckZero
    ) {
      navigate("/feature_not_assigned", {
        state: { unavailableService: "ABeneficiaryTxn" },
      });
      setShowLoader(false);
      return;
    }

    await new Promise((resolve) =>
      setTimeout(resolve, IntervalConfiguration.intervalLarge),
    );

    if (data?.payload?.status === false) {
      const errorMsg = data?.payload?.errors?.user_unauthorized
        ? data?.payload?.errors?.user_unauthorized[0]
        : Array.isArray(data?.payload?.errors?.base) &&
            Array.isArray(data?.payload?.errors?.base[0]?.errors)
          ? data.payload.errors.base[0].errors[0]
          : data?.payload?.errors?.base?.[0];

      CommonToast({
        text: errorMsg,
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
      setShowLoader(false);
      return;
    }

    CommonToast({
      text: "Transaction(s) rejected successfully.",
      icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
      variant: "var(--success)",
      buttonNeeded: false,
    });

    setIsPendingTxnPopupOpen(false);

    if (
      beneficiaryAccount?.pending_scheduled_beneficiary_transactions === "Y"
    ) {
      setIsPendingSchedulePopupOpen(true);
    } else {
      setDeclineReason("");
      await dispatch(beneficiaryAccountDetailsById({ id }));
      await submitBankUpdate();
    }
    setShowLoader(false);
  };

  const handleRejectScheduleTxn = async () => {
    if (showLoader) return;
    setShowLoader(true);
    setIsRejectReasonPopupOpen(false);

    let scheduleIds =
      !scheduledBeneficiaryViewLoading &&
      scheduledBeneficiaryViewData?.transactions?.length >
        GlobalConfiguration.lengthCheckZero
        ? scheduledBeneficiaryViewData?.transactions.map((data) => data?.txn_id)
        : [];

    UniversalRefreshToast("Rejecting schedules.");

    if (scheduleIds.length > GlobalConfiguration.lengthCheckZero) {
      const data2 = await dispatch(
        scheduledBeneficiaryReject({
          id: scheduleIds,
          reason: declineReason,
        }),
      );

      if (
        data2?.payload?.errors?.user_unauthorized?.length >
        GlobalConfiguration.lengthCheckZero
      ) {
        navigate("/feature_not_assigned", {
          state: { unavailableService: "BAScheduledTxn" },
        });
        setShowLoader(false);
        return;
      }

      if (data2?.payload?.status === false) {
        const errorMsg2 = data2?.payload?.errors?.user_unauthorized
          ? data2?.payload?.errors?.user_unauthorized[0]
          : Array.isArray(data2?.payload?.errors?.base) &&
              Array.isArray(data2?.payload?.errors?.base[0]?.errors)
            ? data2.payload.errors.base[0].errors[0]
            : data2?.payload?.errors?.base?.[0];

        CommonToast({
          text: errorMsg2,
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
        setShowLoader(false);
        return;
      } else if (data2?.payload?.status === true) {
        CommonToast({
          text: "Scheduled transactions rejected successfully.",
          icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          variant: "var(--success)",
          buttonNeeded: false,
        });
      }
    }

    setIsPendingSchedulePopupOpen(false);
    setDeclineReason("");
    await dispatch(beneficiaryAccountDetailsById({ id }));
    await submitBankUpdate();
    setShowLoader(false);
  };

  const handleKeyDown = (event) => {
    const isTextField =
      event.target.tagName === "INPUT" || event.target.tagName === "TEXTAREA";

    if (isTextField) return;

    if (event.key === "ArrowLeft" || event.key === "ArrowRight") {
      event.preventDefault();
    }
  };

  const handleEnterKeyPress = useCallback(
    (e) => {
      if (e.key !== "Enter" || e.repeat) return;
      const isTextField =
        e.target.tagName === "INPUT" || e.target.tagName === "TEXTAREA";
      if (isTextField) return;

      e.preventDefault();
      e.stopPropagation();
      if (isRejectReasonPopupOpen) {
        if (
          declineReason &&
          declineReason.length >= GlobalConfiguration.rejectReasonMinLength
        ) {
          if (beneficiaryAccount?.pending_beneficiary_transactions === "Y") {
            handleRejectBeneficiaryTxn(deniedId);
          } else {
            handleRejectScheduleTxn();
          }
        }
        return;
      }

      if (isArchivePopupOpen) {
        validateAndUpdateBank();
        return;
      }

      if (isPendingTxnPopupOpen) {
        setIsRejectReasonPopupOpen(true);
        return;
      }

      if (isPendingSchedulePopupOpen) {
        if (declineReason === "") {
          setIsRejectReasonPopupOpen(true);
        } else {
          handleRejectScheduleTxn();
        }
        return;
      }

      if (
        activeStep === GlobalConfiguration?.lengthCheckZero &&
        isNextButtonEnabled
      ) {
        handleProceedToUpdate();
        return;
      }

      if (
        activeStep === GlobalConfiguration?.lengthCheckOne &&
        isNextButtonEnabled
      ) {
        handleProceedToUpdate();
      }
    },
    [
      activeStep,
      isArchivePopupOpen,
      isPendingTxnPopupOpen,
      isPendingSchedulePopupOpen,
      isRejectReasonPopupOpen,
      declineReason,
      deniedId,
      isNextButtonEnabled,
      validateAndUpdateBank,
      handleProceedToUpdate,
      beneficiaryAccountDetailsData,
    ],
  );

  useEffect(() => {
    if (!beneficiaryAccount) return;

    const hasChanges =
      payload.bank_account !== payload.old_bank_account ||
      payload.ifsc_code !== payload.old_ifsc_code;

    setHasUnsavedChanges(hasChanges);
  }, [
    payload.bank_account,
    payload.ifsc_code,
    payload.old_bank_account,
    payload.old_ifsc_code,
    beneficiaryAccount,
  ]);

  useEffect(() => {
    if (
      !beneficiaryAccountDetailsLoading &&
      !ifscDetailsLoading &&
      !bankLookupLoading &&
      !verifyBankAccountLoading &&
      !bankLookupData?.beneficiary_accounts?.length &&
      !verifyBankAccountError &&
      isIFSCValid &&
      bankLookupError === true &&
      verifyBankAccountData
    ) {
      setShowDetails(true);
    } else {
      setShowDetails(false);
    }
  }, [
    bankLookupLoading,
    verifyBankAccountLoading,
    bankLookupData,
    verifyBankAccountError,
    isIFSCValid,
    beneficiaryAccountDetailsLoading,
    bankLookupError,
    verifyBankAccountData,
    ifscDetailsLoading,
  ]);

  useEffect(() => {
    document.addEventListener("keydown", handleEnterKeyPress);
    return () => document.removeEventListener("keydown", handleEnterKeyPress);
  }, [handleEnterKeyPress]);

  useEffect(() => {
    const fetchBankData = async () => {
      const response = await dispatch(beneficiaryAccountDetailsById({ id }));
      if (response?.error?.message === "Request failed with status code 404") {
        navigate("*");
      }
    };
    fetchBankData();
  }, [dispatch, id, navigate]);

  useEffect(() => {
    if (
      beneficiaryAccountDetailsLoading ||
      beneficiaryAccountDetailsData?.status !== true
    ) {
      return;
    }

    setPayload((prev) => ({
      ...prev,
      name: beneficiaryAccount.name || "",
      bank_account: beneficiaryAccount.bank_acc_no || "",
      ifsc_code: beneficiaryAccount.ifsc_code || "",
      bank_name: beneficiaryAccount.bank_name || "",
      pan_no: beneficiaryAccount.pan_no || "",
      email_id: beneficiaryAccount.email_id || "",
      contact_no: beneficiaryAccount.contact_no || "",
      legal_name: beneficiaryAccount.pan_legal_name || "",
      old_bank_account: beneficiaryAccount.bank_acc_no || "",
      old_ifsc_code: beneficiaryAccount.ifsc_code || "",
      gstin_detail: beneficiaryAccount.gstin_detail || "",
      virtual_account: beneficiaryAccount.virtual_account || "",
      old_virtual_account_type: beneficiaryAccount?.virtual_account_type,
      virtual_account_type: beneficiaryAccount?.virtual_account_type,
      virtual: beneficiaryAccount ? true : "",
    }));
  }, [
    beneficiaryAccountDetailsData,
    beneficiaryAccountDetailsLoading,
    beneficiaryAccount,
  ]);

  useEffect(() => {
    const verificationDetails =
      verifyBankAccountData?.verification_details?.[0];

    const isManualVirtualAccount =
      verificationDetails?.is_virtual === "Y" &&
      verificationDetails?.virtual_account_type === "manual";

    if (!verificationDetails) {
      return;
    }

    if (isManualVirtualAccount) {
      setManualVirtualAccount(true);

      dispatch(resetBankVerificationError());
    }
  }, [verifyBankAccountData, dispatch]);

  useEffect(() => {
    const accs = bankLookupData?.beneficiary_accounts;
    if (accs?.length) {
      lastLookupAccountsRef.current = accs;
    }
  }, [bankLookupData]);

  useEffect(() => {
    const verification = verifyBankAccountData?.verification_details?.[0];
    if (!verification) return;
    const isVirtual =
      verification?.is_virtual === "Y" || verification?.is_virtual === "y";
    setVirtualAccount(isVirtual);
  }, [verifyBankAccountData]);

  useEffect(() => {
    if (activeStep === GlobalConfiguration.lengthCheckOne) return;

    const lookupAccounts =
      bankLookupData?.beneficiary_accounts ||
      lastLookupAccountsRef.current ||
      [];

    let enableNextButton = false;

    const isBankAlreadyLinkedToPan =
      payload?.bank_account?.length >=
        GlobalConfiguration.accountnormalLength &&
      lookupAccounts?.some(
        (val) =>
          payload?.pan_no === val?.pan_no &&
          payload?.bank_account === val?.bank_acc_no &&
          payload?.bank_account !== payload?.old_bank_account,
      );

    setIsBankLinkedAccount(isBankAlreadyLinkedToPan);

    const foundAccount = lookupAccounts?.find(
      (val) =>
        payload?.pan_no === val?.pan_no &&
        payload?.bank_account === val?.bank_acc_no &&
        payload?.bank_account !== payload?.old_bank_account,
    );

    if (foundAccount) {
      setCurrentAssociate(
        foundAccount?.type_of_account === "field_force"
          ? "Field force account"
          : foundAccount?.type_of_account === "reimbursement"
            ? "Reimbursement account"
            : foundAccount?.type_of_account === "tds"
              ? "Tax account"
              : "Beneficiary account",
      );

      setAccountActiveInactiveState(
        ["rejected", "blocked", "archived"].includes(
          foundAccount?.approval_status,
        )
          ? "inactive"
          : "active",
      );
    }

    // 1. Already linked account
    if (isBankAlreadyLinkedToPan) {
      setIsNextButtonEnabled(false);
      return;
    }

    // 2. Invalid bank details
    if (
      payload?.ifsc_code?.length < GlobalConfiguration.ifscLength ||
      !isIFSCValid ||
      payload?.bank_account?.length < GlobalConfiguration.accountnormalLength
    ) {
      setIsNextButtonEnabled(false);
      return;
    }

    // 3. Same bank details
    if (
      payload?.old_bank_account === payload?.bank_account &&
      payload?.old_ifsc_code === payload?.ifsc_code
    ) {
      setIsNextButtonEnabled(false);
      return;
    }

    // 4. Verification error
    if (verifyBankAccountError) {
      setCreateNewEdit(true);
      resetVerificationState();

      setIsNextButtonEnabled(false);
      return;
    }

    // 5. Verification is still loading
    if (verifyBankAccountLoading) {
      setIsNextButtonEnabled(false);
      return;
    }

    // 6. Manual virtual account
    if (manualVirtualAccount && bankLookupData !== null) {
      if (!confirmEnable) {
        setIsNextButtonEnabled(false);
      }

      return;
    }

    // 7. Existing confirmation
    if (confirmEnable && isBankInputValid) {
      setIsNextButtonEnabled(true);
      // setConfirmEnable(false);
      return;
    }

    // 8. New bank + lookup found
    if (isNewBank && !showAlreadyLinkedAlert && bankLookupData !== null) {
      setIsNextButtonEnabled(false);
      return;
    }

    // 9. Valid new bank without lookup result
    if (isBankInputValid && !viretualIndicator && bankLookupData === null) {
      setCreateNewEdit(true);
      enableNextButton = true;
      setIsNextButtonEnabled(enableNextButton);
    }
  }, [
    bankLookupData,
    payload,
    verifyBankAccountLoading,
    isIFSCValid,
    verifyBankAccountError,
    manualVirtualAccount,
  ]);

  useEffect(() => {
    const shouldResetIfsc =
      !payload.bank_account ||
      payload.bank_account.length < GlobalConfiguration.accountnormalLength;

    if (!shouldResetIfsc) return;

    setPayload((prev) => ({
      ...prev,
      ifsc_code: "",
    }));

    setBankVerificationStatus(false);
    setIsBankLinkedAccount(false);
  }, [payload.bank_account]);

  useEffect(() => {
    if (payload?.ifsc_code?.length < GlobalConfiguration.ifscLength) {
      dispatch(resetBankVerificationError());
      resetVerificationState();
    }

    if (!isBankInputValid) {
      lastVerifyRequestRef.current = "";
      lastBankLookupRequestRef.current = "";
      setManualVirtualAccount(false);
      if (verifyBankAccountError === false) {
        dispatch(resetBankVerification());
        dispatch(resetBankLookupData());
        resetVerificationState();
      }

      return;
    }

    const verifyKey = `${payload?.bank_account}-${payload?.ifsc_code}-${payload?.legal_name}`;

    if (lastVerifyRequestRef.current !== verifyKey) {
      lastVerifyRequestRef.current = verifyKey;
      dispatch(
        verifyBankAccount({
          ifsc_code: payload.ifsc_code,
          bank_account: payload.bank_account,
          legal_name: payload.legal_name,
        }),
      );

      dispatch(
        getIFSCDetails({
          search_string: payload.ifsc_code,
          page_no: GlobalConfiguration.lengthCheckOne,
          page_size: GlobalConfiguration.filterResults,
        }),
      );
      // Bank lookup should not happen for manual virtual account

      const bankLookupKey = `${payload.ifsc_code}-${payload.bank_account}`;

      if (lastBankLookupRequestRef.current !== bankLookupKey) {
        lastBankLookupRequestRef.current = bankLookupKey;

        dispatch(
          bankLookUp({
            ifsc: payload.ifsc_code,
            bank_account_no: payload.bank_account,
          }),
        );
      }
    } else {
      if (virtualType !== "Mark-Virtual" && !manualVirtualAccount) {
        dispatch(resetBankVerification());
      }
      dispatch(resetBankLookupData());
    }
  }, [
    dispatch,
    isBankInputValid,
    manualVirtualAccount,
    payload.ifsc_code,
    payload.bank_account,
    payload.legal_name,
  ]);

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, []);

  useEffect(() => {
    if (verifyBankAccountLoading) return;
    if (verifyBankAccountData?.status === true) {
      setBankVerificationStatus(true);
    } else if (verifyBankAccountData?.status === false) {
      setBankVerificationStatus(false);
    }
  }, [verifyBankAccountData, verifyBankAccountLoading]);

  useEffect(() => {
    if (!isBankInputValid) {
      setIsOriginalManualVirtual(false);
      setVirtualType("");
      setConfirmEnable(false);
      setIsNextButtonEnabled(false);
    }
  }, [isBankInputValid]);

  const rejectPopupContent = (() => {
    if (isPendingSchedulePopupOpen) {
      return {
        headerTitle: "Rejecting Schedules",
        bulletPoints: [
          "Once rejected, no transaction will be created.",
          "Rejected schedules cannot be edited. Create a new schedule instead.",
        ],
      };
    }

    if (isPendingTxnPopupOpen) {
      return {
        headerTitle: "Rejecting Transactions",
        bulletPoints: [
          "Transaction will be rejected, and distribution will not be initiated.",
          "Transaction cannot be edited but can be recreated.",
        ],
      };
    }

    return {
      headerTitle: "Reject account",
      bulletPoints: [
        globalText.REJECT_POPUP_BULLET_POINT_ONE,
        globalText.REJECT_POPUP_BULLET_POINT_TWO,
        globalText.REJECT_POPUP_BULLET_POINT_THREE,
      ],
    };
  })();

  return (
    <>
      {isPendingTxnPopupOpen && (
        <LargePopupRedirect
          headerTitle="Pending transactions found"
          headersubtext="The following transactions are linked and need to be rejected before archiving this account."
          closeiconenabledBgColor="var(--primary-nav)"
          closeiconisLoading={false}
          closeiconhandleFunction={() => {
            setIsPendingTxnPopupOpen(false);
            setDeclineReason("");
          }}
          closeicon={ICONS?.CLOSE}
          closeiconhoverOption="white"
          closeiconbtnType={"button"}
          closeiconisDisabled={false}
          closeicondisabledBgColor={""}
          closeiconbuttonRef={null}
          closeicontitle={"Close"}
          btnType={"button"}
          bottomHeaderTextNeed={true}
          bottomHeaderText={`To archive the account, please reject the transactions listed above by clicking the "Reject all" button.`}
          isbottomSectionneed={true}
          btnText={"Reject all"}
          confirmbtnrequired={true}
          handleFunction={() => {
            const hasAccess = services?.find(
              (service) => service === "ABeneficiaryTxn" || service === "Admin",
            );
            if (!hasAccess) return;
            setIsRejectReasonPopupOpen(true);
          }}
          isLoaderNeeded={true}
          isLoading={showLoader ? true : false}
          enabledBgColor={"var(--negative-act)"}
          hoverOption={"dark"}
          outLineColor={""}
          enabledTextColor={"var(--text-primary)"}
          fullWidthRequired={false}
          inActiveVariantNeeded
          isDisabled={
            services?.find((service) => service === "ABeneficiaryTxn") ===
            undefined
          }
          disabledTextColor={"var(--text-primary)"}
          disabledBgColor={"var(--text-disabled)"}
        >
          <BeneficiaryTransactionsViewAll
            bene_account_id={payload?.bene_account_id || id}
            typepop={"BeneAccRejectTxn"}
            type={payload?.type || "bene_account_detail_modal"}
            alert={"alertpopup"}
            flow={"beneficiary_txnViewAll_popup_reject"}
            closeRejectAllTxn={() => {
              setIsPendingTxnPopupOpen(false);
              setDeclineReason("");
            }}
            TxnHistoryid={beneficiaryAccount?.id}
            bene_account_name={beneficiaryAccount?.name}
          />
        </LargePopupRedirect>
      )}

      {isPendingSchedulePopupOpen && (
        <LargePopupRedirect
          headerTitle="Pending schedules found"
          headersubtext="The following schedules are linked and need to be rejected before archiving this account."
          headerFontWeight="semibold"
          headerFontColor="text-primary"
          headertextSize="font-md"
          closeiconbtnType="button"
          closeiconhandleFunction={() => {
            setIsPendingSchedulePopupOpen(false);
            setDeclineReason("");
          }}
          closeiconisDisabled={false}
          closeiconenabledBgColor="var(--primary-nav)"
          closeicondisabledBgColor="var(--text-disabled)"
          closeiconhoverOption="white"
          closeicon={ICONS?.CLOSE}
          btnType={"button"}
          bottomHeaderTextNeed={true}
          bottomHeaderText={
            "To archive the account, please reject the schedules listed above by clicking the “Reject all” button. The schedules will get rejected with the provided rejected reason."
          }
          isbottomSectionneed={true}
          btnText={"Reject all"}
          confirmbtnrequired={true}
          handleFunction={() => {
            const hasAccess = services?.find(
              (service) => service === "BAScheduledTxn" || service === "Admin",
            );
            if (!hasAccess) return;
            if (declineReason === "") {
              setIsRejectReasonPopupOpen(true);
            } else {
              handleRejectScheduleTxn();
            }
          }}
          enabledBgColor={"var(--negative-act)"}
          hoverOption={"dark"}
          outLineColor={""}
          enabledTextColor={"var(--text-primary)"}
          inActiveVariantNeeded
          isDisabled={
            services?.find((service) => service === "BAScheduledTxn") ===
            undefined
          }
          disabledTextColor={"var(--text-primary)"}
          disabledBgColor={"var(--text-disabled)"}
        >
          <ScheduleBeneficiaryTransactionViewSchedules
            type={"ScheduleAccBeneAcc"}
            payload={{
              schedule_acc_id: beneficiaryAccount?.id || id,
              schedule_acc_name: beneficiaryAccount?.name,
              handleRejectAllTransaction: handleRejectScheduleTxn,
            }}
            closeCallback={() => {
              setIsPendingSchedulePopupOpen(false);
              setDeclineReason("");
            }}
          />
        </LargePopupRedirect>
      )}

      {isRejectReasonPopupOpen && (
        <div className="fixed top-top-base left-left-base w-full h-full bg-PopUp-BackDrop bg-opacity-dark-opacity flex items-center justify-center z-z-index-modal">
          <SmallPopupWithInput
            headerTitle={rejectPopupContent.headerTitle}
            headerFontWeight="semibold"
            headerFontColor="text-primary"
            textSize="font-md"
            secondHeaderTitle="Provide the reason for rejection."
            secondHeaderFontColor="text-secondary"
            secondHeaderTextSize="font-xs"
            noteText={globalText?.REJECT_POPUP_ACCOUNT_NOTE_TEXT}
            noteColor="text-secondary"
            bulletPoints={rejectPopupContent.bulletPoints}
            inputPlaceholder={globalText.REASON}
            inputVariant={computeVariant(declineReason, isFocused)}
            inputOnFocus={() => setIsFocused(true)}
            inputOnBlur={() => setIsFocused(false)}
            inputIsDisabled={showLoader ? true : false}
            btnOneIsDisabled={showLoader ? true : false}
            inputBgColor="var(--primary-bg)"
            inputFgColor="var(--text-secondary)"
            inputOnInput={(e) => {
              if (!showLoader) {
                handleInputChange(e);
              }
            }}
            inputValue={declineReason}
            inputFontKind="small"
            inputIsFullWidth={true}
            btnOneText="Cancel"
            btnOneHandleFunction={() => {
              if (!showLoader) {
                setDeclineReason("");
                setIsRejectReasonPopupOpen(false);
              }
            }}
            btnOneEnabledBgColor="var(--primary-bg)"
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneHoverOption="white"
            btnTwoText="Reject"
            btnTwoHandleFunction={() => {
              if (
                beneficiaryAccount?.pending_beneficiary_transactions === "Y"
              ) {
                handleRejectBeneficiaryTxn(deniedId);
              } else {
                handleRejectScheduleTxn(deniedId);
              }
            }}
            btnTwoEnabledBgColor="var(--negative-act)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={
              !declineReason ||
              declineReason.length < GlobalConfiguration.rejectReasonMinLength
            }
            btnTwoDisabledBgColor="var(--text-disabled)"
            btnTwoInActiveVariantNeeded={true}
            btnTwoIsLoaderNeeded={showLoader ? true : false}
            btnTwoIsLoading={showLoader ? true : false}
            btnTwoHoverOption="black"
          />
        </div>
      )}

      {isArchivePopupOpen && (
        <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
          <SmallPopupWithBulletPoints
            headerTitle={"Account update"}
            headerFontWeight="semibold"
            headerFontColor="text-primary"
            textSize="font-md"
            noteColor="text-secondary"
            btnOneText="Cancel"
            btnOneBtnType="button"
            btnOneEnabledBgColor="transparent"
            btnOneHandleFunction={() => setIsArchivePopupOpen(false)}
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneIsDisabled={false}
            btnOneHoverOption="white"
            btnTwoText="Proceed"
            btnTwoIsLoaderNeeded
            btnTwoIsLoading={updateActive}
            btnTwoBtnType="button"
            btnTwoHandleFunction={validateAndUpdateBank}
            btnTwoEnabledBgColor="var(--positive-act)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={false}
            btnTwoHoverOption="black"
            bulletPoints={[
              "The old account will be archived and become inactive.",
              "The new account will be created as an active beneficiary account.",
              "Inactive accounts cannot be used to create transactions.",
            ]}
          />
        </div>
      )}

      {isLeavePopupOpen && (
        <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
          <SmallPopup
            headerTitle={globalText?.LEAVE_PAGE_WARNING_HEADER}
            headerFontWeight="semibold"
            headerFontColor="text-primary"
            textSize="font-md"
            subtext={
              payload.bank_account.length <
                GlobalConfiguration.accountnormalLength ||
              payload?.ifsc_code?.length < GlobalConfiguration.ifscLength
                ? "Leaving this page will exit from the current flow."
                : globalText?.EXIT_CURRENT_FLOW_NOTE
            }
            btnOneText={globalText?.STAY}
            btnOneBtnType="button"
            btnOneEnabledBgColor="transparent"
            btnOneHandleFunction={() => setIsLeavePopupOpen(false)}
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneIsDisabled={false}
            btnOneHoverOption="white"
            btnTwoText={globalText?.LEAVE}
            btnTwoBtnType="button"
            btnTwoHandleFunction={handleLeavePage}
            btnTwoEnabledBgColor="var(--negative-act)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={false}
            btnTwoHoverOption="black"
          />
        </div>
      )}
      <div className="bg-primary-bg flex overflow-y-hidden flex-col h-full-height">
        <div className="flex flex-col items-center max-w-tab-width-normal mx-auto my-margin-base w-full bg-primary-nav rounded-b-border-radius-md">
          <div className="min-h-navbar-breadcrumb-height hidden Qmd:block"></div>
          <div className="flex justify-center items-end !bottom-bottom-base Qsmd:min-h-[calc(var(--stepper-height)+var(--icon-sm))] min-h-stepper-height Qsmd:bg-transparent rounded-t-border-radius-md Qmd:relative Qlg:bg-transparent bg-primary-nav rounded-b-border-radius-sm w-screen fixed Qsmd:top-top-base left-left-base z-z-index-overlay">
            <PrimaryStepper
              activeStep={activeStep}
              handleForwardAction={handleProceedToUpdate}
              handleBackwardAction={handleBack}
              dataArray={dataArray}
            />
          </div>
          <div className="fixed top-top-base left-left-base mt-margin-base w-width-full rounded-bl-border-radius-md rounded-br-border-radius-md z-z-index-header bg-primary-nav shadow-box-shadow-bottom lg:hidden block">
            <TopNavComponent
              topNavHeader="Beneficiary Account"
              topNavSubText="Bank details"
              isFormattingNotRequired
            />
          </div>
          <div className="h-[var(--stepper-height)] block Qmd:hidden"></div>
        </div>
        <div
          className="w-width-full overflow-auto Qsmd:pt-padding-md Qsmd:pb-padding-md pt-padding-base h-full flex justify-center"
          style={{ scrollbarWidth: "none" }}
        >
          <div className="w-width-full">
            <div
              className="px-padding-md lg:px-padding-base py-padding-md Qsmd:py-padding-base max-w-tab-width-normal w-full mx-auto Qsmd:!pb-padding-md"
              style={{ scrollbarWidth: "none" }}
            >
              {activeStep === GlobalConfiguration.lengthCheckZero ? (
                <BeneficiaryAccountEditStepBank
                  isResolving={isResolving}
                  bankLookupNext={bankLookupNext}
                  setBankLookupNext={setBankLookupNext}
                  setIsNextButtonEnabled={setIsNextButtonEnabled}
                  payload={payload}
                  setPayload={setPayload}
                  activeStep={activeStep}
                  bankLookupData={bankLookupData}
                  isIFSCValid={isIFSCValid}
                  isBankLinkedAccount={isBankLinkedAccount}
                  accountActiveInactiveState={accountActiveInactiveState}
                  setAccountActiveInactiveState={setAccountActiveInactiveState}
                  currentAssociate={currentAssociate}
                  setCurrentAssociate={setCurrentAssociate}
                  openAssociatePopup={openAssociatePopup}
                  setOpenAssociatePopup={setOpenAssociatePopup}
                  dropDownOptions={dropDownOptions}
                  virtualAccount={virtualAccount}
                  setVirtualAccount={setVirtualAccount}
                  bankVerificationStatus={bankVerificationStatus}
                  setBankVerificationStatus={setBankVerificationStatus}
                  verifyBankAccountError={verifyBankAccountError}
                  setBankUserInfo={setBankUserInfo}
                  setShowAccInfo={setShowAccInfo}
                  showJointAccountAlert={showJointAccountAlert}
                  showAlreadyLinkedAlert={showAlreadyLinkedAlert}
                  isVirtualDetected={isVirtualDetected}
                  createNewedit={createNewedit}
                  id={id}
                  isNextButtonEnabled={isNextButtonEnabled}
                  isNewBank={isNewBank}
                  manualVirtualAccount={manualVirtualAccount}
                  setManualVirtualAccount={setManualVirtualAccount}
                  setConfirmEnable={setConfirmEnable}
                  ifscDetailsError={ifscDetailsError}
                  ifscDetailsLoading={ifscDetailsLoading}
                  bankLookupError={bankLookupError}
                  setIsOriginalManualVirtual={setIsOriginalManualVirtual}
                  isOriginalManualVirtual={isOriginalManualVirtual}
                  virtualType={virtualType}
                  setVirtualType={setVirtualType}
                  verifiyBankAccountMessage={verifiyBankAccountMessage}
                  verifyBankAccountData={verifyBankAccountData}
                  beneficiaryAccountDetailsLoading={
                    beneficiaryAccountDetailsLoading
                  }
                  verifyBankAccountLoading={verifyBankAccountLoading}
                  bankLookupLoading={bankLookupLoading}
                  ifscData={ifscData}
                  showDetails={showDetails}
                />
              ) : (
                <BeneficiaryAccountEditStepBankConfirm
                  activeStep={activeStep}
                  setActiveStep={setActiveStep}
                  payload={payload}
                  manualVirtualAccount={isOriginalManualVirtual}
                />
              )}
            </div>
          </div>
        </div>
        <div className="h-stepper-moble-height flex-shrink-0 Qsmd:h-pagination-height block Qsmd:hidden"></div>
      </div>
    </>
  );
};

export default BeneficiaryAccountEditBank;
